import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFrax = function SvgFrax(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 122 122"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 61,
        cy: 61,
        r: 60,
        fill: "#000",
        stroke: "#000",
        strokeWidth: 1.237
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M23.263 32.56c.02-.042 2.108-2.277 4.638-4.933l4.574-4.891.928.906c.506.506 2.635 2.53 4.723 4.512 1.002.962 2.01 1.919 2.837 2.705.895.851 1.58 1.502 1.822 1.743l.864.844.76-.464a35 35 0 0 1 2.424-1.286c3.204-1.603 6.345-2.551 10.182-3.1 1.602-.231 6.789-.189 8.517.064 3.332.485 6.199 1.35 9.277 2.762 1.012.463 2.825 1.454 3.541 1.94.253.189.528.316.57.294.063-.02 2.424-2.466 5.27-5.439 2.846-2.993 5.229-5.418 5.313-5.418.126 0 9.613 8.96 9.698 9.17.02.064-2.404 2.657-5.376 5.756l-5.418 5.671.4.696c.822 1.392 2.235 4.427 2.699 5.777 3.204 9.213 2.171 19.206-2.783 27.449l-.59.97 1.286 1.222c3.879 3.647 10.225 9.74 10.246 9.804.02.126-9.234 9.803-9.319 9.76-.084-.042-8.517-8.053-10.773-10.245l-1.033-1.012-.97.59c-3.731 2.256-8.285 3.795-12.88 4.322-2.383.295-6.642.19-8.876-.211-4.449-.801-8.475-2.32-11.912-4.512l-.675-.421-.716.717c-.38.4-2.889 3.035-5.566 5.84l-4.87 5.08-.316-.274c-.823-.675-9.445-9.002-9.424-9.065l.22-.233c.679-.722 2.847-3.024 5.409-5.691 3.078-3.226 5.629-5.925 5.671-6.009s-.148-.548-.57-1.265c-.863-1.454-1.875-3.668-2.466-5.397-3.141-9.15-2.108-19.1 2.888-27.364l.57-.95-.317-.294c-.13-.115-1.63-1.548-3.605-3.434l-1.813-1.732c-2.804-2.656-5.08-4.89-5.06-4.954m49.142 12.291c-2.761-1.94-5.755-3.078-9.107-3.478-8.096-.97-15.96 3.288-19.586 10.583-.906 1.855-1.391 3.183-1.75 5.038-.379 1.877-.379 5.419 0 7.316 1.202 5.966 4.955 10.942 10.268 13.661 7.357 3.753 16.106 2.488 22.157-3.162 7.084-6.641 8.159-17.477 2.53-25.446-.991-1.413-3.1-3.521-4.512-4.512",
        clipRule: "evenodd"
    })));
};

export { SvgFrax as ReactComponent };
//# sourceMappingURL=FRAX.svg.es.js.map
